'use strict';

var style = require('./style');

module.exports = style({
  prop: 'lineHeight',
  key: 'lineHeights'
});


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/styled-system/dist/line-height.js
// module id = 4494
// module chunks = 168707334958949